import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PhoneButton from '@/components/base/PhoneButton';

const services = [
  {
    slug: 'acil-kapi-acma',
    icon: 'ri-door-open-line',
    title: 'Acil Kapı Açma',
    desc: 'Evinizin, işyerinizin veya aracınızın kapısı kilitli kaldıysa panik yapmayın. Alfa Çilingir ekibi çağrı aldıktan sonra ortalama 15 dakika içinde adresinizde olur. Tüm kapı tipleri için hasarsız açma garantisi veriyoruz.',
    details: ['Daire kapısı açma', 'İşyeri kapısı açma', 'Bodrum & depo kapısı açma', 'Apartman giriş kapısı açma'],
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20opening%20residential%20apartment%20door%20with%20specialized%20tools%2C%20close%20up%20skilled%20hands%2C%20modern%20door%20lock%2C%20professional%20service%20uniform%2C%20Istanbul%20Turkey&width=700&height=450&seq=hsvc001&orientation=landscape',
  },
  {
    slug: 'kilit-degistirme',
    icon: 'ri-lock-2-line',
    title: 'Kilit Değiştirme',
    desc: 'Eski, hasarlı veya güvenliğinden şüphe duyduğunuz kilitlerini en kaliteli markalarla değiştiriyoruz. Taşınma sonrası kilit değişimi, kiracı çıkışı sonrası güvenlik güncellemesi gibi durumlarda hızlı hizmet.',
    details: ['Silindir kilit değişimi', 'Çelik kapı kilit değişimi', 'Barel değişimi', 'Akıllı kilit montajı'],
    img: 'https://readdy.ai/api/search-image?query=locksmith%20installing%20new%20high%20security%20door%20lock%2C%20replacing%20old%20lock%20cylinder%2C%20professional%20tools%2C%20modern%20apartment%20door%2C%20close%20up%20detail%20work&width=700&height=450&seq=hsvc002&orientation=landscape',
  },
  {
    slug: 'celik-kapi-acma',
    icon: 'ri-shield-keyhole-line',
    title: 'Çelik Kapı Açma',
    desc: 'Çelik kapılar özel ekipman ve uzmanlık gerektirir. Ekibimiz tüm marka ve model çelik kapılarda hasarsız açma konusunda deneyimlidir. Kapınıza zarar vermeden, hızlı ve güvenli şekilde açıyoruz.',
    details: ['Tüm marka çelik kapılar', 'Hasarsız açma garantisi', 'Kilit değişimi dahil', 'Acil müdahale'],
    img: 'https://readdy.ai/api/search-image?query=heavy%20duty%20steel%20security%20door%20with%20multiple%20lock%20points%2C%20professional%20locksmith%20examining%20door%2C%20apartment%20building%20hallway%2C%20Turkey%20residential%20building&width=700&height=450&seq=hsvc003&orientation=landscape',
  },
  {
    slug: 'oto-cilingir',
    icon: 'ri-car-line',
    title: 'Oto Çilingir',
    desc: 'Araç anahtarınızı kaybettiniz, kırdınız veya araç içinde unuttunuz mu? Tüm araç marka ve modellerinde anahtar kopyalama, kapı açma ve immobilizer çözümleri sunuyoruz.',
    details: ['Tüm araç markaları', 'Anahtar kopyalama', 'Araç kapısı açma', 'Immobilizer çözümü'],
    img: 'https://readdy.ai/api/search-image?query=automotive%20locksmith%20opening%20car%20door%20with%20professional%20tools%2C%20modern%20vehicle%2C%20urban%20street%2C%20skilled%20technician%2C%20car%20key%20service&width=700&height=450&seq=hsvc004&orientation=landscape',
  },
  {
    slug: 'kasa-acma',
    icon: 'ri-safe-line',
    title: 'Kasa Açma',
    desc: 'Şifreli veya anahtarlı kasaları güvenle açıyor, kombinasyon sıfırlama ve kilit değişimi yapıyoruz. Ev kasaları, ofis kasaları ve otel kasaları dahil tüm kasa tiplerinde hizmet.',
    details: ['Şifreli kasa açma', 'Anahtarlı kasa açma', 'Kombinasyon sıfırlama', 'Kasa kilit değişimi'],
    img: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20opening%20combination%20safe%20box%2C%20office%20environment%2C%20security%20safe%2C%20skilled%20technician%20with%20specialized%20tools%2C%20focused%20work&width=700&height=450&seq=hsvc005&orientation=landscape',
  },
  {
    slug: 'anahtar-kopyalama',
    icon: 'ri-key-2-line',
    title: 'Anahtar Kopyalama',
    desc: 'Her türlü anahtar kopyalama ve yedek anahtar yapımı hizmetimizle yedek anahtarınızı hızlıca çıkarıyoruz. Ev anahtarı, araç anahtarı, ofis anahtarı ve özel anahtarlar dahil.',
    details: ['Ev anahtarı kopyalama', 'Araç anahtarı kopyalama', 'Ofis & depo anahtarı', 'Özel anahtar yapımı'],
    img: 'https://readdy.ai/api/search-image?query=key%20cutting%20machine%20duplicating%20house%20key%2C%20locksmith%20shop%2C%20various%20keys%2C%20professional%20key%20copying%20service%2C%20close%20up%20detail%2C%20modern%20equipment&width=700&height=450&seq=hsvc006&orientation=landscape',
  },
];

export default function HizmetlerPage() {
  useEffect(() => {
    document.title = 'Çilingir Hizmetleri | Alfa Çilingir Beylikdüzü - Kapı Açma, Kilit Değiştirme';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de profesyonel çilingir hizmetleri: acil kapı açma, kilit değiştirme, çelik kapı açma, oto çilingir, kasa açma, anahtar kopyalama. 7/24 hizmet.');

    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${siteUrl}/hizmetler`;

    const existingScript = document.getElementById('schema-hizmetler');
    if (existingScript) existingScript.remove();

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/hizmetler#webpage`,
          url: `${siteUrl}/hizmetler`,
          name: 'Çilingir Hizmetleri | Alfa Çilingir',
          description: 'Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de profesyonel çilingir hizmetleri.',
          inLanguage: 'tr-TR',
          isPartOf: { '@id': `${siteUrl}/#website` },
        },
        {
          '@type': 'ItemList',
          name: 'Alfa Çilingir Hizmetleri',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Acil Kapı Açma' },
            { '@type': 'ListItem', position: 2, name: 'Kilit Değiştirme' },
            { '@type': 'ListItem', position: 3, name: 'Çelik Kapı Açma' },
            { '@type': 'ListItem', position: 4, name: 'Oto Çilingir' },
            { '@type': 'ListItem', position: 5, name: 'Kasa Açma' },
            { '@type': 'ListItem', position: 6, name: 'Anahtar Kopyalama' },
          ],
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Hizmetler', item: `${siteUrl}/hizmetler` },
          ],
        },
      ],
    };

    const script = document.createElement('script');
    script.id = 'schema-hizmetler';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-hizmetler');
      if (s) s.remove();
      const c = document.querySelector('link[rel="canonical"]');
      if (c) c.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 bg-gray-900 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=locksmith%20tools%20spread%20on%20dark%20surface%2C%20professional%20equipment%2C%20keys%20wrenches%20picks%2C%20dark%20moody%20background%2C%20top%20view%20flat%20lay%20photography&width=1920&height=500&seq=hpage001&orientation=landscape"
              alt="Çilingir Hizmetleri"
              className="w-full h-full object-cover object-top opacity-30"
            />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
            <span className="inline-flex items-center gap-2 text-orange-400 text-xs font-bold uppercase tracking-widest mb-4">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-tools-line"></i></span>
              Profesyonel Çilingir Hizmetleri
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
              Tüm Çilingir Hizmetlerimiz
            </h1>
            <p className="text-gray-300 max-w-2xl mx-auto text-base md:text-lg mb-8">
              Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir'de 7/24 profesyonel çilingir hizmeti. Acil durumda hemen arayın.
            </p>
            <PhoneButton size="lg" />
          </div>
        </section>

        {/* Services List */}
        <section className="py-16 md:py-24 bg-stone-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="space-y-12">
              {services.map((svc, idx) => (
                <article
                  key={svc.title}
                  className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 bg-white rounded-2xl overflow-hidden border border-stone-100`}
                >
                  <div className="lg:w-2/5 h-64 lg:h-auto">
                    <img
                      src={svc.img}
                      alt={svc.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="lg:w-3/5 p-6 md:p-8 flex flex-col justify-center">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="w-11 h-11 flex items-center justify-center bg-orange-50 text-orange-500 rounded-xl">
                        <i className={`${svc.icon} text-xl`}></i>
                      </span>
                      <h2 className="text-xl md:text-2xl font-extrabold text-gray-900">{svc.title}</h2>
                    </div>
                    <p className="text-gray-500 text-sm leading-relaxed mb-5">{svc.desc}</p>
                    <ul className="grid grid-cols-2 gap-2 mb-6">
                      {svc.details.map((d) => (
                        <li key={d} className="flex items-center gap-2 text-sm text-gray-700">
                          <span className="w-4 h-4 flex items-center justify-center text-orange-500">
                            <i className="ri-check-line text-sm"></i>
                          </span>
                          {d}
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href="tel:05416247982"
                        className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold px-6 py-3 rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer w-fit text-sm"
                      >
                        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill"></i></span>
                        Hemen Ara: 0541 624 79 82
                      </a>
                      <Link
                        to={`/hizmetler/${svc.slug}`}
                        className="inline-flex items-center gap-2 border-2 border-orange-500 text-orange-500 hover:bg-orange-50 font-bold px-6 py-3 rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer w-fit text-sm"
                      >
                        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                        Detaylı Bilgi
                      </Link>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-orange-500">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3">Acil Çilingir mi Lazım?</h2>
            <p className="text-orange-100 mb-6 text-base">7/24 hizmetinizdeyiz. Hemen arayın, 15 dakikada yanınızda olalım.</p>
            <a
              href="tel:05416247982"
              className="inline-flex items-center gap-3 bg-white text-orange-500 font-extrabold px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-all duration-200 text-lg"
            >
              <span className="w-6 h-6 flex items-center justify-center"><i className="ri-phone-fill text-xl"></i></span>
              0541 624 79 82
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
